import { useState, useEffect } from "react";
import { Icon } from "../icons";
import { Link } from "react-router-dom";
import { getSidebarItem } from "../../services/SidebarService";
import { useSelector } from "react-redux";
import store from "../../store";
import _ from "lodash";

const SidebarMenuItem = (props) => {
  const { app, item } = props;
  const isActive = item.active === undefined ? false : item.active;
  const activeClass = app === "tenken" ? "bg-[#2e90fa] text-white" : "bg-[#F3D168]";
  const inactiveClass =
    app === "tenken"
      ? "bg-[#eaeaea] hover:bg-[#e7e3e3] hover:text-[#2e90fa]"
      : "bg-[#faf3db] hover:bg-[#f5f0c8]";
  const sidebarItem = getSidebarItem(app, item.name);
  const menuClass = isActive === false ? inactiveClass : activeClass;
  const icon = isActive === false ? sidebarItem.icon : `${sidebarItem.icon}-active`;
  const isDisabledSidebar = useSelector(
    (state) => state.button_processing.isProcessingButton
  );
  const divClass = isDisabledSidebar ? "w-full pointer-events-none cursor-not-allowed" : "w-full";
  const fontSize = sidebarItem.text.length > 7 ? "text-[14px]" : ""
  const auth = store.getState().auth;
  const notifications = auth.notifications;
  const [hasAprovalRequest, setHasApprovalRequest] = useState(false);
  useEffect(() => {
    const approvalRequestExists = notifications?.approval_request_exists > 0;
    setHasApprovalRequest(approvalRequestExists)
  }, [notifications]);
  return (
    <div className={divClass}>
      <div className={`flex flex-col items-center rounded-[8px] py-[8px] ${menuClass} relative`}>
        <Link to={sidebarItem.link} className={"w-full text-center"}>
          <Icon
            name={icon}
            height="24px"
            width="24px"
            className="mx-auto mb-[4px]"
          />
          <span className={fontSize}>{sidebarItem.text}</span>
        </Link>
        {item.name === 'judgment' && hasAprovalRequest &&
        <div className="absolute w-4 h-4 rounded-full bg-red-500 right-[-4px] top-[-4px]"></div>
        }
      </div>
    </div>
  );
};

export default SidebarMenuItem;
